import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { useHotkey } from '@modules/common/hooks';
import {
  Button,
  DialogActions,
  DialogContent,
  Divider,
  Typography,
} from '@mui/material';

interface AddIntegrationDiscardConfirmationDialogProps {
  onDiscardChanges: () => void;
}

export const AddIntegrationDiscardConfirmationDialog = ({
  onDiscardChanges,
}: AddIntegrationDiscardConfirmationDialogProps) => {
  const { closeModal } = useMuiModalContext();

  useHotkey({
    hotkey: 'esc',
    onHotkey: () => closeModal(),
  });

  return (
    <>
      <ModalHeader
        title="Discard progress on Integration?"
        showCloseButton={false}
      />
      <Divider light />
      <DialogContent>
        <Typography color="text.secondary" sx={{ py: 1 }}>
          You will lose all your progress on creating this integration. Do you
          wish to proceed?
        </Typography>
      </DialogContent>
      <Divider light />
      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={() => {
            onDiscardChanges();
            closeModal();
          }}
          variant="outlined"
          color="warning"
        >
          Discard Changes
        </Button>
        <Button onClick={() => closeModal()} variant="contained">
          Go Back
        </Button>
      </DialogActions>
    </>
  );
};
